// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'


import { string } from 'yup';

const obj =  {
	field:[
		
        { 
			title: "Country", 
			attr: "content",  
			value: "", 
			id:"country",
			placeholder: "Specify the country to generate href tag", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Country is  Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Language", 
			attr: "content",  
			value: "", 
			id:"language",
			placeholder: "Specify article to generate semantic relevance", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Language is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],
    example:[
	
        { 
			title: "Country", 
			attr: "content",  
			value: "USA", 
			id:"country",
			placeholder: "Specify the country to generate href tag", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Country is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "language", 
			attr: "content",  
			value: "English", 
			id:"language",
			placeholder: "Specify article to generate semantic relevance", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Language is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output: "<link rel=\"alternate\" hreflang=\"en-us\" href=\"http://example.com/us\"/>"
		
	}
	}
	
	
	export default obj
	
	